import shortid from "shortid";

import { DataService } from "../services";

// const store = () => import("base/stores");

const IMAGE_DATA_PATTERNS = [/^data:image/, /^blob:/, /^file:/];

export function generateId(prefix) {
  return `${prefix}_${shortid.generate()}`;
}

export async function loadRecaptcha() {
  // const { useAccountStore } = await store();
  // const { AppConfig } = useAccountStore.getState();
  const script = document.createElement("script");
  script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${window.accountDetails.AppConfig.ReCaptchaSiteKey}`;
  document.body.appendChild(script);
  return new Promise((resolve) => {
    script.onload = () => {
      resolve();
    };
  });
}

function checkValidImageURL(url) {
  let currentHost = window.location.host;
  try {
    let imageRegex = /.(png|jpeg|jpg|svg|gif)$/;
    if (imageRegex.test(url)) {
      let incomingURL = new URL(url);
      let { host } = incomingURL;
      let domain = host.split(".").reverse()?.[1];
      if (currentHost.includes(domain)) {
        return { isPublic: false, sameDomain: true };
      }
      return { isPublic: true, sameDomain: false };
    }
    return { isPublic: false, sameDomain: false };
  } catch (e) {
    return { isPublic: false, sameDomain: false };
  }
}

export async function getImageFromBlobOrURL({
  url,
  flowType,
  flowId,
  imageConfig = {},
  imageBlob,
  onComplete,
  triggerCompleteCallBackOnLoad = true,
  shouldIncludeAttachmentId = true
}) {
  let { isPublic, sameDomain = false } = checkValidImageURL(url);
  const callbackId = generateId("");
  if (!flowType && !flowId) {
    return;
  }
  let imageDataurl = false;
  let baseURL = `/upload/2/${window.accountDetails._id}/`;
  if (IMAGE_DATA_PATTERNS.some((pattern) => pattern.test(url))) {
    imageDataurl = true;
  }
  const uploadModule = await import("widgets/inputs");
  const { UploadWrapper } = await uploadModule;
  const fileUpload = new UploadWrapper(baseURL, `${flowType}/${flowId}`);
  if (imageConfig) {
    fileUpload.config = {
      ...fileUpload.config,
      ...imageConfig
    };
  }
  const callback = (err, data) => {
    if (
      err &&
      err.error_code === "KISSFLOW_ERROR_16001" &&
      imageBlob instanceof Blob
    ) {
      isPublic = false;
      fileUpload.upload(imageBlob, isPublic, callback);
    } else {
      onComplete(err, data, {
        isPublic,
        callbackId,
        blobURL:
          imageBlob instanceof Blob ? URL.createObjectURL(imageBlob) : url
      });
    }
    return;
  };
  if (triggerCompleteCallBackOnLoad) {
    onComplete(
      null,
      {},
      {
        isPublic,
        callbackId,
        blobURL:
          imageBlob instanceof Blob ? URL.createObjectURL(imageBlob) : url
      }
    );
  }

  if (imageDataurl || sameDomain) {
    if (imageDataurl && !(imageBlob instanceof Blob)) {
      imageBlob = await DataService.download(url);
      const [, extension] = imageBlob.type.split("/");
      imageBlob.name = `${flowType}_${flowId}.${extension}`;
    }
    fileUpload.upload(imageBlob, isPublic, callback);
  } else {
    fileUpload.uploadFromUrl(
      {
        url,
        isPublic,
        flowType,
        flowId,
        toast: false,
        shouldIncludeAttachmentId
      },
      callback
    );
  }
}

export * from "./date";
export * from "./number";
export * from "./currency";
export * from "./currencymap";
export * from "./utils";
export * from "./attachment";
export * from "./mousewheel";
export * from "./browser.helpers";
export * from "./serviceworker";
// eslint-disable-next-line import/export
export * from "./syncuserstatus";
export * from "./sdk.executor";
export * from "./geolocation";
export * from "./markdown";
export * from "./timer";
export * from "./task.delegation";
